import { constantes } from '../constantes';
import { FilterService } from '../interfaces/filter-service.interface';
import { Service } from '../interfaces/service.interface';
import { Company } from '../interfaces/company.interface';
import { Injectable } from '@angular/core';
import { InfoService } from 'src/app/interfaces/infoservice.interface';
import { FilterCompany } from 'src/app/interfaces/filter-company.interface';

@Injectable({
  providedIn: 'root'
})
export class DataService {
	
	
	private companiesAll:Company[];
	private servicesAll:Service[];
	private infoServicesAll:InfoService[];
	
	companies:Company[];
	services:Service[];
	infoServices:InfoService[];
	
	showCompany:boolean = true;
	showService:boolean = true;
	showInfos:boolean = true;
	showRoute:boolean = false;
	showAddress:boolean = false;
	showSectors:boolean = true;
	
	selectedSectors:any = {};
	selectedSectorsInfos:any = {};
	
	map:google.maps.Map;
	
	
	
	
	constructor(
		
	) { }
	
	
	calculateAddress(item:Company | Service):string
	{
		return (item.Number ? item.Number + ' ' : '') + (item.Bis ? item.Bis + ' ' : '') + ' '+item.Street + ' ' + (item.BP ? item.BP + ' ' : '') + item.CP + ' ' + item.City;
	}
	
	
	initData(data:any):void
	{
		this.companiesAll = data['companies'];
		this.servicesAll = data['services'];
		this.infoServicesAll = data['infos'];
		
		//calculate full address
		
		this.companiesAll.forEach((item:Company) => {
			item.address = this.calculateAddress(item);
			item.visible = true;
		});
		this.servicesAll.forEach((item:Service) => {
			item.address = this.calculateAddress(item);
			item.visible = true;
		});
		this.infoServicesAll.forEach((item:InfoService) => {
			item.visible = true;
		});
		
		
		this.resetCompany();
		this.resetServices();
		this.resetInfoServices();
		
		this.resetSelectedSectors(constantes.sectors);
		this.resetSelectedSectorsInfos(constantes.sectors);
	}
	
	
	
	resetCompany():void{
		this.companies = this.companiesAll;
	}
	resetServices():void{
		this.services = this.servicesAll;
	}
	resetInfoServices():void{
		this.infoServices = this.infoServicesAll;
	}
	
	
	
	resetSelectedSectors(sectors:any[]):void
	{
		let tmp:any = {...this.selectedSectors};
		sectors.forEach(sector => {
			tmp[sector.label] = true;
		});
		this.selectedSectors = tmp;
	}
	toggleSelectedSector(id:string):void
	{
		let tmp:any = {...this.selectedSectors};
		if (!this.selectedSectors[id]) tmp[id] = true;
		else tmp[id] = false;
		this.selectedSectors = tmp;
	}
	
	
	resetSelectedSectorsInfos(sectors:any[]):void
	{
		sectors.forEach(sector => {
			this.selectedSectorsInfos[sector.label] = true;
		});
	}
	toggleSelectedSectorInfos(id:string):void
	{
		if (!this.selectedSectorsInfos[id]) this.selectedSectorsInfos[id] = true;
		else this.selectedSectorsInfos[id] = false;
	}
	
	
	
	
	
	
	
	//effet de bord : set item.visible
	
	filterCompany(filters:FilterCompany):void
	{
		let outputs:Company[] = this.companiesAll.filter((company:Company) => {
			
			
			let output:boolean = true;
			if(output && filters.name != '' && this.normalizeString(company.name).search(this.normalizeString(filters.name)) == -1) output = false;
			if(output && filters.activity != '' && company.domain != filters.activity) output = false;
			
			if(output && filters.sector != '' && company.sector != filters.sector) output = false;
			if(output && filters.firstLetter != '' && company.name.charAt(0).toLowerCase() != filters.firstLetter) output = false;
			
			if(output && filters.cles && !company.cles) output = false;
			if(output && filters.peps && !company.peps) output = false;
			
			company.visible = output;
			return output;
		});
		
		// debugger;
		
		this.companies = outputs;
	}
	
	
	
	
	filterService(filters:FilterService):void
	{
		let emptyfilter:boolean = Object.values(filters).every(value => !value);
		
		let outputs:Service[] = this.servicesAll.filter((service:Service) => {
			
			let output:boolean = true;
			
			//si serviceType == null, ça veut dire que le type de ce service
			//n'est pas listé, (genre autre)
			//donc on l'affiche
			
			let serviceType:any = constantes.serviceTypes.find(elmt => elmt.dbvalue == service.type);
			if(serviceType && output && !emptyfilter && !filters[serviceType.id]){
				output = false;
			}
			if(!serviceType && !emptyfilter) output = false;
			
			
			service.visible = output;
			return output;
		});
		
		// debugger;
		
		this.services = outputs;
		
	}
	
	
	
	filterInfos(selectedSectors:string[]):void
	{
		let outputs:InfoService[] = this.infoServicesAll.filter((infos:InfoService) => {
			
			let output:boolean = false;
			
			if(infos.sectors.length == 0) output = true;
			else{
				
				for(let label in selectedSectors){;
					let value = selectedSectors[label];
					
					//si A == true, et si info.sectors contient A
					if(value && infos.sectors.indexOf(label) != -1){
						output = true;
						break;
					}
				}
			}
			
			infos.visible = output;
			// debugger;
			return output;
		});
		
		this.infoServices = outputs;
		// debugger;
	}
	
	
	
	
	
	normalizeString(str:string):string
	{
		return str.toLowerCase();
	}
	
	
}
